import React, { FC } from 'react';
import { HealthCheckupInstitution } from '../../query';
import { Row } from './Row';
import styles from './HealthCheckupInstitutionsTable.scss';

interface HealthCheckupInstitutionsTableProps {
  health_checkup_institutions: HealthCheckupInstitution[];
  refetch: () => void;
}

export const HealthCheckupInstitutionsTable: FC<HealthCheckupInstitutionsTableProps> = ({
  health_checkup_institutions,
  refetch
}) => {
  return (
    <div className="l-overflow-scroll">
      <table className={styles.table}>
        <thead>
          <tr className={styles.header}>
            <th className={styles.healthCheckupInstitutionIdColumn} rowSpan={2}>
              ID
            </th>
            <th className={styles.nameColumn} rowSpan={2}>
              名称
            </th>
            <th className={styles.locationColumn} rowSpan={2}>
              所在地
            </th>
            <th className={styles.actionsColumn} rowSpan={2}>
              アクション
            </th>
          </tr>
        </thead>
        <tbody>
          {health_checkup_institutions.length > 0 &&
            health_checkup_institutions.map(health_checkup_institution => (
              <Row
                key={health_checkup_institution.name}
                healthCheckupInstitution={health_checkup_institution}
                refetch={refetch}
              />
            ))}
        </tbody>
      </table>
    </div>
  );
};
